import script from "./KbsMyPending.vue?vue&type=script&setup=true&lang=js"
export * from "./KbsMyPending.vue?vue&type=script&setup=true&lang=js"

import "./KbsMyPending.vue?vue&type=style&index=0&id=10c57308&scoped=true&lang=css"

import exportComponent from "D:\\Workspace-idea\\vue-space\\hwoms-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10c57308"]])

export default __exports__